import { RxComponent } from 'app/core/components/common/rx.component';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'itpx-preview-common',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.css']
})
export class PreviewCommonComponent extends RxComponent {

    data: any;

    constructor() {
        super();
    }

    ngOnInit() {

        let iFrameDocument = document.querySelector('#email-holder')['contentWindow'].document;
        let content = this.data.template;
        iFrameDocument.open('text/html', 'replace');
        if (this.data.css) iFrameDocument.write(`<head>${this.data.css}</head>`);
        iFrameDocument.write(`<div class="ql-editor">${content}</div>`);
        iFrameDocument.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/common/template/preview/preview.component.ts